import { ForwardedRef, useRef } from 'react';

/**
 * In some cases ref is forwarded via forwardRef API (f.e. autocomplete input)
 * in other cases it is not - we would like to assert the ref is always present
 * and that we would like to use actual instance to leverage scrolling behavior
 */

export const useAssertedRef = <T>(ref?: ForwardedRef<T>) => {
  const internalRef = useRef<T | null>(null);

  return ref ?? internalRef;
};
